// Mercapoli - Delivery Orders History
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Package, Loader2 } from 'lucide-react';
import { Badge } from '../../components/ui/badge';
import { Card, CardContent } from '../../components/ui/card';
import { pedidos as pedidosApi } from '../../lib/api';

const DeliveryOrders = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [pedidos, setPedidos] = useState([]);

  useEffect(() => {
    loadPedidos();
  }, []);

  const loadPedidos = async () => {
    try {
      const data = await pedidosApi.getAll();
      setPedidos(data);
    } catch (error) {
      console.error('Error:', error);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 glass border-b border-border/50">
        <div className="container-app">
          <div className="flex items-center h-16 gap-4">
            <button onClick={() => navigate('/delivery')} className="p-2 -ml-2 rounded-lg hover:bg-muted">
              <ArrowLeft className="h-5 w-5" />
            </button>
            <h1 className="font-heading text-lg font-bold">Historial de entregas</h1>
          </div>
        </div>
      </header>

      <div className="container-app py-6">
        {loading ? (
          <div className="flex justify-center py-12">
            <Loader2 className="h-8 w-8 animate-spin text-spicy-coral" />
          </div>
        ) : pedidos.length === 0 ? (
          <div className="text-center py-12">
            <Package className="h-12 w-12 mx-auto mb-4 text-muted-foreground" />
            <p className="text-muted-foreground">No hay entregas en tu historial</p>
          </div>
        ) : (
          <div className="space-y-3">
            {pedidos.map((pedido) => (
              <Card key={pedido.pedido_id}>
                <CardContent className="p-4">
                  <div className="flex items-start justify-between mb-2">
                    <div>
                      <p className="font-bold">Pedido #{pedido.pedido_id.slice(-6)}</p>
                      <p className="text-sm text-muted-foreground">
                        {new Date(pedido.created_at).toLocaleDateString('es-MX')}
                      </p>
                    </div>
                    <Badge className={`status-${pedido.estado}`}>
                      {pedido.estado.replace('_', ' ')}
                    </Badge>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-muted-foreground">Total del pedido</span>
                    <span className="font-bold">${pedido.total.toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between text-sm mt-1">
                    <span className="text-muted-foreground">Tu ganancia</span>
                    <span className="font-bold text-zesty-lime">$25.00</span>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default DeliveryOrders;
